import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useSnapshot } from "valtio";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { capitalize } from "@helpers/general";

import { deviceStore, setIsAssociateConfirmOpened } from "../store";

// POS-scoped confirmation alert for the device associate modal. Its open state
// and the message both come from the POS device store (NOT the global
// VerticalLayout store), so: (1) it cannot leak onto another page — the flag is
// cleared by resetDeviceStore() on every modal close, and (2) the message
// reflects the POS selection instead of the always-empty Kiosk store.
export function PosAssociateConfirmModal() {
    const { t } = useTranslation();
    const {
        isAssociateConfirmOpened,
        printers,
        monetics,
        cashManagements,
        printerSelected,
        selectedPeripherals,
    } = useSnapshot(deviceStore);

    const hasSelection =
        printers.length > 0 ||
        monetics.length > 0 ||
        cashManagements.length > 0 ||
        printerSelected.length > 0 ||
        selectedPeripherals.length > 0;

    return (
        <StyledModal toggle={true} isOpen={isAssociateConfirmOpened} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => setIsAssociateConfirmOpened(false)}
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-4">
                    {hasSelection
                        ? t(
                              "The data has not changed! Do you want to continue?"
                          )
                        : t("Attention ! You must select at least one device")}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomMainColorButton
                    rounded
                    variant="primary"
                    onClick={() => setIsAssociateConfirmOpened(false)}
                >
                    {t("Ok")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
